import {TFunction} from 'i18next';

export const validateEmailField =
  (t: TFunction) =>
  ({
    email,
  }: {
    email?: string;
  }): {
    email?: string;
  } => {
    if (!email) {
      return {
        email: t('mgw.subscribeEmailRequired'),
      };
    }

    const atIndex = email.indexOf('@');
    if (atIndex <= 0 || atIndex === email.length - 1) {
      return {
        email: t('mgw.subscribeWrongEmail'),
      };
    }

    return {};
  };
